var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 3.5H2C1.17157 3.5 0.5 4.17157 0.5 5V19C0.5 19.8284 1.17157 20.5 2 20.5H22C22.8284 20.5 23.5 19.8284 23.5 19V5C23.5 4.17157 22.8284 3.5 22 3.5Z",
  fill: "#243747"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 16C11.7091 16 13.5 14.2091 13.5 12C13.5 9.79086 11.7091 8 9.5 8C7.29086 8 5.5 9.79086 5.5 12C5.5 14.2091 7.29086 16 9.5 16Z",
  fill: "#E61C24"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4668 16C16.6759 16 18.4668 14.2091 18.4668 12C18.4668 9.79086 16.6759 8 14.4668 8C12.2577 8 10.4668 9.79086 10.4668 12C10.4668 14.2091 12.2577 16 14.4668 16Z",
  fill: "#F99F1B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9833 8.86816C11.5105 9.24191 11.1285 9.71784 10.8659 10.2603C10.6032 10.8027 10.4668 11.3975 10.4668 12.0002C10.4668 12.6028 10.6032 13.1977 10.8659 13.7401C11.1285 14.2825 11.5105 14.7584 11.9833 15.1322C12.4561 14.7584 12.8381 14.2825 13.1007 13.7401C13.3633 13.1977 13.4998 12.6028 13.4998 12.0002C13.4998 11.3975 13.3633 10.8027 13.1007 10.2603C12.8381 9.71784 12.4561 9.24191 11.9833 8.86816Z",
  fill: "#F26622"
});

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.6cdef1fbfe9126fce8ca6a1377cd322d.svg";
export { ForwardRef as ReactComponent };